export default class ContractCorrections {
  id?: number;
  typeError: string;
  errorDescription: string;
  formalizationId?: number;

  constructor(entity: ContractCorrections) {
    this.id = entity.id;
    this.typeError = entity.typeError;
    this.errorDescription = entity.errorDescription;
    this.formalizationId = entity.formalizationId;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/ContractCorrections.tsx